import type { JSX, Ref } from 'react'
import type { ILayoutBlockProps } from '../LayoutBlock'

import { LayoutBlockPlayerSC } from './LayoutBlockPlayer.styles'

export type ILayoutBlockPlayerProps = ILayoutBlockProps & {
  ref?: Ref<HTMLDivElement>
  miniPlayer?: boolean
  visible?: boolean
  autoplayTrailer?: boolean
}

export function LayoutBlockPlayer({
  ref,
  children,
  width = '100%',
  height = '100%',
  miniPlayer = false,
  visible = true,
  autoplayTrailer = false,
  ...rest
}: ILayoutBlockPlayerProps): JSX.Element {
  return (
    <LayoutBlockPlayerSC
      ref={ref}
      blockWidth={width}
      blockHeight={height}
      miniPlayer={miniPlayer}
      visible={visible}
      data-mini-player={miniPlayer ? 'true' : undefined}
      data-autoplay-trailer={autoplayTrailer ? 'true' : undefined}
      {...rest}
    >
      {children}
    </LayoutBlockPlayerSC>
  )
}
